import React, {useEffect, useState} from 'react';
import {useNavigate, useParams, useSearchParams} from "react-router-dom";
import BackServer from "../../api/BackServer";
import {baseUrl_back} from "../../api/BaseUrl";
import BreadPath from "../BreadPath/BreadPath";
import {Container, Grid} from "@mui/material";
import {MDBBtn, MDBContainer, MDBSpinner} from "mdb-react-ui-kit";
import OneProductDetail from "../OneProductDetail/OneProductDetail";
import NewOneProductMiddle from "../newOneProductMiddle/newOneProductMiddle";
import {Button, Typography} from "antd";

const ProductCard = (props) => {
    const params = useParams();
    let navigate = useNavigate();

    {/* eslint-disable-next-line */}
    // ym(92960084,'reachGoal','DetailProduct')
    var myParams = {perehodVproduct: {product_id: params.product_id}};
    {/* eslint-disable-next-line */}
    // ym(92960084, 'params', {params: myParams});
    console.log(myParams)


    const [wait, setWait]= useState(false)
    const product_id = params.product_id;
    const [myproducts, setmyproducts] = useState([])
    const [otherProd, setotherProd] = useState([])
    const [visOther, setvisOther] = useState(false)
    const [myprodName, setmyprodName] = useState("продукт")
    const [category, setCategory] = useState([])
    const [toggler, setToggler] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();
    var Fromkey= searchParams.get("Fromkey")
    var Fromlink= searchParams.get("Fromlink")




    // console.log("dd")
    const getProducts = async () => {
        const response = await BackServer.GetProductById(params.product_id)
        console.log(response)
        {setmyprodName(response.message.products[0].name)}
        setmyproducts(response.message.products)
        setotherProd(response.message.otherColor)
        setvisOther(response.message.otherColorVis)
        setWait(false)
    }


    const callup = (len) => {
        props.callbackX(len)

    }
    const Bread=[{key:"Главная", link:"/"}, {key:"Каталог", link:"/catalog"},{key:myprodName, link:"/products/"+product_id+ "?Fromkey="+Fromkey+"&Fromlink="+Fromlink} ]
    useEffect(() => {
        setWait(true)
        getProducts()
    }, [])
    return   (
        <>
        <Container maxWidth="xl">
            <BreadPath key={"ddd"} path={Bread}/>
            {searchParams["fromCat"]}
            {(wait==true)?
                (
                    <div className='d-flex justify-content-center'>
                        <MDBBtn color='danger' disabled>
                            <MDBSpinner  size='sm' role='status' tag='span' className='me-2' />
                            Загрузка описания товара...
                        </MDBBtn>
                    </div>
                ):(
            <MDBContainer fluid>
                {myproducts.map((elm, key) => (
                    <>

                        <OneProductDetail key={key} callbak={callup} elm={elm} label={elm.name}
                                          img={baseUrl_back + elm.imageUrl} urlx={elm.Url}/>
                    </>
                ))}
            </MDBContainer>)}

                    {/*<OneProductGlass key={"dd"}   callbak={callup} elm={myproducts} label={myproducts.name} img={baseUrl_back+myproducts.imageUrl}  urlx={myproducts.Url} />*/}
        </Container>
            <Container  maxWidth="xl">
                <div className="my-flex-cont">

                    {/*<div className="my-flex-box">*/}
                    {/*    <ProductFilters call={MyCallBack} filters={distinct}/>*/}
                    {/*</div>*/}
                    <div className="my-flex-box">
        {(visOther)?(
            <>
            <Button style={{marginTop: "20px", backgroundColor: "#382b2f"}} color="default" size={"large"}
                    variant="solid" block>Другие товары с этим принтом</Button>
            <p></p>

                <Grid direction={"row"} container spacing={0.75}>
                {otherProd.map((elm, key) => (
                        //             (elm.show==true)?(
                        <Grid item key={key}  lg={3} xl={2.4} sm={6} md={4} xs={12}>
                            <NewOneProductMiddle  key={elm.article} visfoto={true}   callbak={callup} elm={elm} label={"1234"} img={elm.images[0]["file_name"]}  urlx={"superlink"} />
                            {/*<a>{elm.article}</a>*/}
                        </Grid>
                    )
                )}
                </Grid>

             </>):(
            (wait==true)?
                (
                    <div className='d-flex justify-content-center'>
                        <MDBBtn color='danger' disabled>
                            <MDBSpinner  size='sm' role='status' tag='span' className='me-2' />
                            Поиск товаров с этим принтом...
                        </MDBBtn>
                    </div>
                ):(
            <Typography  style={{ textAlign: "center"}}>К сожалению других изделий с таким принтом у нас пока нет</Typography>)
)}
                    </div>
                </div>
            </Container>
        </>
);
};

export default ProductCard;